import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { RootState } from 'cityads-v3/types/reducer'

type PermissionChecker = (permission: string) => boolean

export function useCheckPermission(): PermissionChecker {
  const permissions = useSelector<RootState, string[]>(state => state.auth.user?.permissions || []);

  return useCallback((permission: string): boolean => {
    return permissions.includes(permission)
  }, [permissions])
}
